import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Icon from "@material-ui/core/Icon/Icon";
import Grid from "@material-ui/core/Grid/Grid";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Divider from "@material-ui/core/Divider/Divider";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";

export default class CourseDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTab: 0
        };
    }

    changeHouse = (event, value) => {
        this.setState({showTab: value});
    };

    selectContract = (event, index) => {
        this.setState({ selectedIndex: index });
    };


    render() {
        const {course, houses} = this.props

        return (
            <section>
                {houses.length && (
                    <div>
                        <Typography variant="h6" gutterBottom>
                            {i18n.get('contacts.linked_houses')}
                        </Typography>

                        <Tabs onChange={this.changeHouse} value={this.state.showTab}>
                            {houses.map(house => (
                                <Tab label={house.name} key={house.name} />
                            ))}
                        </Tabs>

                        <br/>

                        {houses.map((house, index) => (
                            <div key={index}>
                                {this.state.showTab === index && (
                                    <Grid container spacing={16}>
                                        <Grid item>

                                            <List component="nav" style={{padding: 0, width: 250}}>

                                                <ListItem divider>
                                                    {/* view_list, assignment */}
                                                    <ListItemIcon>
                                                        <Icon>description</Icon>
                                                    </ListItemIcon>
                                                    <ListItemText primary={i18n.get('contracts.contracts')} />
                                                </ListItem>

                                                <ListItem
                                                    button
                                                    selected={this.state.selectedIndex === 2}
                                                    onClick={event => this.selectContract(event, 2)}
                                                >
                                                    <ListItemText primary="Trash" />
                                                </ListItem>
                                                <ListItem
                                                    divider
                                                    button
                                                    selected={this.state.selectedIndex === 3}
                                                    onClick={event => this.selectContract(event, 3)}
                                                >
                                                    <ListItemText primary="Spam" />
                                                </ListItem>

                                                <ListItem
                                                    button
                                                    selected={this.state.selectedIndex === 4}
                                                    onClick={event => this.selectContract(event, 4)}
                                                >
                                                    {/* view_list, assignment */}
                                                    <ListItemIcon>
                                                        <Icon>add</Icon>
                                                    </ListItemIcon>
                                                    <ListItemText primary={i18n.get('contracts.new')} />
                                                </ListItem>
                                            </List>

                                        </Grid>

                                        <Grid item>
                                            <Typography>
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi dicta doloremque minus. <br/>
                                                Ad aspernatur beatae delectus dolor doloremque earum facere facilis fuga ipsa laudantium, possimus repellendus, soluta tenetur. <br/>
                                                Pariatur, voluptas.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Courses/CourseDetails.js